module.exports = ['$translate', $translate => (text) => {
  // We want to keep Month-Day in en locale, but Day-Month in fr_CA locale
  let noBreakPattern;
  if ($translate.use() === 'fr_CA') {
    noBreakPattern = /(.*?)(\d+[^\s]*\s+[^\s]+)(.*)/;
  } else {
    noBreakPattern = /(.*?)([^\s]+\s+\d+[^\s]*)(.*)/;
  }

  // Check if there is a number-word sequence in the provided text
  const matchedPatterns = text.match(noBreakPattern);
  if (matchedPatterns) {
    // If so, wrap this pattern (tightly) in a no-wrap span
    return `${matchedPatterns[1]}<span class='_text-nowrap'>${matchedPatterns[2]}</span>${matchedPatterns[3]}`;
  }
  return text;
}];



// WEBPACK FOOTER //
// ./main/filters/no-number-word-break-filter.js